import {Language} from "../../LanguageConfig";

/**
 * Represents a structure for language definition responses used in AJAX operations.
 */
export interface LanguageDefinitionAjaxResponses {
    informAdmin: string
    savingSuccess: string
    deleteSuccess: string
    restoreSuccess: string
    errors: {
        [ key: string ]: string | Function
        errorAppeared: (view: string, action: string ) => string,
        400: string,
        401: string,
        404: string,
        500: string,
        loginWrongPassword: string,
        loginUserNotFound: string
    }
}

/**
 * Helper function to create multi language error messages
 */
export function createErrorResponse(
    language: Language,
    status: number,
    viewIdentifier: string,
    actionName: string
) {
    return language.ajaxResponse.errors[status.toString()] + ' ' + language.ajaxResponse.errors.errorAppeared(viewIdentifier, actionName ) + ' ' + language.ajaxResponse.informAdmin;
}